import { useState } from 'react';

const faqItems = [
  {
    question: 'İzmir\'de vize danışmanlığı hizmeti ne kadar sürer?',
    answer: 'Başvuru türüne ve ülkeye göre değişmekle birlikte, evrak hazırlığı genellikle 2-5 iş günü içinde tamamlanır. Randevu ve konsolosluk değerlendirme süreci ülkeye göre farklılık gösterir.',
  },
  {
    question: 'lhglobalpass.com.tr hangi vize türlerinde hizmet veriyor?',
    answer: 'Schengen C ve D tipi vizeler, Amerika vizesi, İngiltere vizesi, e-vizeler, kapı vizeleri, oturum kartı başvuruları ve aile birleşimi başvurularında profesyonel danışmanlık hizmeti sunulmaktadır.',
  },
  {
    question: 'Vize danışmanlık ücreti ne kadar?',
    answer: 'Ücretler başvurulan ülkeye, vize türüne ve hizmet kapsamına göre değişiklik gösterir. Şeffaf fiyatlandırma politikası kapsamında başvuru öncesinde detaylı bilgilendirme yapılmaktadır. Güncel fiyat bilgisi için iletişime geçebilirsiniz.',
  },
  {
    question: 'Schengen vizesi için hangi belgeler gereklidir?',
    answer: 'Geçerli pasaport, biyometrik fotoğraf, seyahat sigortası, konaklama belgesi, uçuş rezervasyonu, banka hesap dökümü ve gelir belgesi temel evraklar arasındadır. Başvurulan ülkeye göre ek belgeler istenebilir.',
  },
  {
    question: 'Amerika vizesi başvurusunda mülakat zorunlu mu?',
    answer: 'Evet, Amerika vizesi başvurularında konsolosluk mülakatı zorunludur. DS-160 form hazırlığı ve mülakat öncesi danışmanlık hizmeti ile süreci daha güvenli yönetebilirsiniz.',
  },
  {
    question: 'Yunanistan vizesi için Kosmos sistemi nasıl çalışır?',
    answer: 'Kosmos, Yunanistan vizesi başvurularında kullanılan randevu ve başvuru yönetim sistemidir. Randevu alma, evrak yükleme ve başvuru takibi bu sistem üzerinden gerçekleştirilir. Profesyonel destek ile süreç daha hızlı ilerler.',
  },
  {
    question: 'Vize reddedilirse ne yapılabilir?',
    answer: 'Red kararı sonrasında itiraz süreci veya yeniden başvuru seçenekleri değerlendirilebilir. Ret gerekçesi analiz edilerek eksik belgeler tamamlanır ve yeni başvuru stratejisi oluşturulur.',
  },
  {
    question: 'İzmir dışından da hizmet alabilir miyim?',
    answer: 'Evet, online danışmanlık ve evrak yönetimi hizmetleri sayesinde Türkiye\'nin farklı şehirlerinden de başvuru desteği alınabilmektedir. Detaylı bilgi için iletişime geçebilirsiniz.',
  },
];

const SeoArticleSection = () => {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8 max-w-4xl">

        {/* Intro */}
        <div className="mb-16 text-center">
          <p className="text-sm text-gray-500 font-light mb-3 tracking-wider uppercase">Rehber</p>
          <p className="text-gray-600 leading-relaxed max-w-3xl mx-auto">
            Yurt dışı seyahat planlarında en önemli adımlardan biri, doğru ve eksiksiz vize başvurusu yapmaktır. <strong>İzmir Vize Danışmanlık</strong> hizmetleri, bu sürecin daha hızlı ve sorunsuz ilerlemesini sağlar. <strong>lhglobalpass.com.tr</strong>, başvuru sürecinin her aşamasında profesyonel destek sunarak kullanıcıların işini kolaylaştırır. Firma, evrak hazırlığından randevu yönetimine kadar tüm süreci planlı şekilde yürütür.
          </p>
        </div>

        {/* Article Content */}
        <article className="prose-custom space-y-16">

          {/* H2 - 1 */}
          <div>
            <h2 className="text-3xl font-bold text-navy mb-5 pb-3 border-b border-gray-100">
              İzmir Vize Danışmanlık Ücretleri
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Vize danışmanlık ücretleri, başvurulan ülkeye ve hizmet kapsamına göre değişiklik gösterebilir. <strong>İzmir Vize Danışmanlık</strong> hizmetlerinde fiyatlar genellikle evrak hazırlığı, randevu alma ve başvuru takibi gibi süreçleri kapsar. <strong>lhglobalpass.com.tr</strong>, ücretlendirme konusunda şeffaf bir yaklaşım benimser. Başvuru öncesinde detaylı bilgilendirme yapılması, kullanıcıların süreci daha net anlamasını sağlar.
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              Ücretler belirlenirken hizmet kalitesi ve destek kapsamı önemli rol oynar. En düşük fiyat yerine doğru hizmeti almak uzun vadede daha avantajlıdır. Öğrenci, turistik veya ticari vizelerde ücretler değişkenlik gösterebilir. Bu nedenle başvuru öncesi net bilgi almak önemlidir.
            </p>
            <ul className="space-y-2">
              {['Ülkeye göre değişen ücretler', 'Hizmet kapsamına göre fiyatlandırma', 'Ek hizmetler (VIP başvuru vb.)', 'Şeffaf ve ön bilgilendirme'].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-gray-600">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-gold text-lg"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* H2 - 2 */}
          <div>
            <h2 className="text-3xl font-bold text-navy mb-5 pb-3 border-b border-gray-100">
              İzmir'de Vize Danışmanlığı İçin lhglobalpass.com.tr Güvenilir Mi?
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Vize başvurularında güvenilir bir danışmanlık firması ile çalışmak sürecin en önemli noktalarından biridir. <strong>İzmir Vize Danışmanlık</strong> firmaları arasında seçim yaparken referanslar ve deneyim büyük önem taşır. <strong>lhglobalpass.com.tr</strong>, sektörde edindiği tecrübe ile güven veren firmalar arasında yer alır.
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              Başvuru sürecinin her aşamasında kullanıcıya net bilgi sunulması güven oluşturur. Evrak kontrolü titizlikle yapılır ve eksik belge riski azaltılır. Ayrıca başvuru sonrası süreç de yakından takip edilir. Güvenilir bir firma ile çalışmak vize onay ihtimalini de olumlu etkileyebilir.
            </p>
            <ul className="space-y-2">
              {['Deneyimli danışman kadro', 'Şeffaf süreç yönetimi', 'Evrak kontrol desteği', 'Sürekli bilgilendirme'].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-gray-600">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-gold text-lg"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* H2 - 3 */}
          <div>
            <h2 className="text-3xl font-bold text-navy mb-5 pb-3 border-b border-gray-100">
              Yunanistan – Kosmos Vize Başvurusu Nasıl Yapılır?
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Yunanistan vizesi başvuruları, belirli prosedürlere uygun şekilde yapılmalıdır. <strong>Vize Danışmanlık İzmir</strong> hizmetleri, bu sürecin doğru şekilde ilerlemesine yardımcı olur. Kosmos aracılığıyla yapılan başvurularda randevu sistemi büyük önem taşır. <strong>lhglobalpass.com.tr</strong>, randevu alma ve evrak hazırlama süreçlerinde kullanıcıya destek sağlar.
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              Başvuru dosyasının eksiksiz hazırlanması, sürecin olumlu ilerlemesi açısından kritik bir faktördür. Biyometri işlemleri de belirlenen merkezlerde yapılır. Başvuru sonrası değerlendirme süreci birkaç hafta sürebilir. Bu nedenle erken başvuru yapmak avantaj sağlar.
            </p>
            <ul className="space-y-2">
              {['Randevu alma süreci', 'Evrak hazırlama desteği', 'Biyometri işlemleri', 'Başvuru takibi'].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-gray-600">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-gold text-lg"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* H2 - 4 */}
          <div>
            <h2 className="text-3xl font-bold text-navy mb-5 pb-3 border-b border-gray-100">
              İzmir Schengen Vize Alma Rehberi (2026)
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Schengen vizesi, Avrupa ülkelerine seyahat etmek isteyenler için önemli bir gerekliliktir. <strong>İzmir Vize Danışmanlık</strong> hizmetleri, Schengen başvurularında sürecin doğru yönetilmesini sağlar. <strong>lhglobalpass.com.tr</strong>, başvuru sahiplerine gerekli evraklar konusunda detaylı rehberlik sunar.
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              Finansal belgeler, seyahat planı ve konaklama detayları doğru şekilde sunulmalıdır. Ayrıca başvuru yapılacak ülkenin konsolosluk kuralları dikkate alınmalıdır. Schengen vizesi başvurularında hata payı oldukça kritiktir. Bu nedenle profesyonel danışmanlık süreci kolaylaştırır.
            </p>
            <ul className="space-y-2">
              {['Evrak listesi hazırlığı', 'Konsolosluk kurallarına uygunluk', 'Seyahat planı düzenleme', 'Başvuru takibi'].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-gray-600">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-gold text-lg"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* H2 - 5 */}
          <div>
            <h2 className="text-3xl font-bold text-navy mb-5 pb-3 border-b border-gray-100">
              İzmir Vize Danışmanlık ve Başvuru Fiyatları (2026)
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Vize başvuru sürecinde hem danışmanlık hem de resmi harç ücretleri birlikte değerlendirilmelidir. <strong>İzmir Vize Danışmanlık</strong> hizmetleri kapsamında fiyatlar, hizmet kapsamına göre farklılık gösterir. <strong>lhglobalpass.com.tr</strong>, kullanıcılarına uygun fiyat ve kaliteli hizmet dengesi sunmayı hedefler.
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              Turistik, ticari ve öğrenci vizelerinde farklı ücretlendirme yapılır. Ayrıca konsolosluk harçları da toplam maliyeti etkiler. Bu nedenle tüm süreç önceden planlanmalıdır. Şeffaf fiyat politikası, kullanıcıların güvenini artırır.
            </p>
            <ul className="space-y-2">
              {['Danışmanlık hizmet bedeli', 'Konsolosluk harçları', 'Başvuru türüne göre değişim', 'Ek hizmet seçenekleri'].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-gray-600">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-gold text-lg"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* H2 - 6 */}
          <div>
            <h2 className="text-3xl font-bold text-navy mb-5 pb-3 border-b border-gray-100">
              Profesyonel Vize Danışmanlık Hizmeti Nasıl Olmalı?
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Kaliteli bir vize danışmanlık hizmeti, sürecin başından sonuna kadar kullanıcıya destek sunmalıdır. <strong>İzmir Vize Danışmanlık</strong> hizmetlerinde profesyonellik, detaylara verilen önemle kendini gösterir. <strong>lhglobalpass.com.tr</strong>, bu süreçte kullanıcı odaklı yaklaşımıyla öne çıkar.
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              Evrak hazırlığı titizlikle yapılmalı ve eksik belge riski ortadan kaldırılmalıdır. Başvuru sürecinde sürekli bilgilendirme yapılması güven oluşturur. Deneyimli ekip, olası sorunlara hızlı çözüm sunar. Profesyonel hizmet, vize alma sürecini kolaylaştırır.
            </p>
            <ul className="space-y-2">
              {['Detaylı evrak kontrolü', 'Sürekli iletişim', 'Planlı süreç yönetimi', 'Deneyimli danışman kadro'].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-gray-600">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-gold text-lg"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
          </div>

        </article>

        {/* FAQ Section */}
        <div className="mt-20">
          <div className="text-center mb-12">
            <p className="text-sm text-gray-500 font-light mb-3 tracking-wider uppercase">SSS</p>
            <h2 className="text-3xl lg:text-4xl font-bold text-navy">
              Sıkça Sorulan Sorular
            </h2>
            <p className="text-gray-500 mt-3 text-sm">İzmir vize danışmanlığı hakkında merak edilenler</p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className="border border-gray-100 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full flex items-center justify-between px-6 py-5 text-left bg-white hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
                  aria-expanded={openFaq === index}
                >
                  <span className="font-semibold text-navy text-base pr-4">{item.question}</span>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className={`ri-${openFaq === index ? 'subtract' : 'add'}-line text-gold text-xl transition-transform duration-300`}></i>
                  </div>
                </button>
                {openFaq === index && (
                  <div className="px-6 pb-5 bg-amber-50/40">
                    <p className="text-gray-600 leading-relaxed text-sm pt-3">{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default SeoArticleSection;
